export default __webpack_public_path__ + "static/media/Plus.af0952b8.svg";